import { css } from '@emotion/core';
import { media, tokens, variables } from '@domain-group/fe-brary';
export var listingMap = /*#__PURE__*/css("background-color:", tokens.colors.neutral.surface.default, ";", media('>=desktop'), "{width:", variables.global.tabletMaxWidth, ";height:auto;margin-bottom:0;}");
export var heading = /*#__PURE__*/css("margin-top:14px;", media('>=desktop'), "{margin-top:auto;}");
export var staticAddress = {
  name: "1r2f04i",
  styles: "margin-bottom:10px;"
};